let langData = {
	"ru": {
		"chooseSectionOrItem": "Выберите подраздел или товар: ",
		"loading": "Загрузка...",
		"adding": "Добавление...",
		"addToCompare": "Добавить к сравнению",
		"chooseProduct": "Выберите товар",
		"chooseSection": "Выберите раздел",
	},
	"ua": {
		"chooseSectionOrItem": "Оберіть підрозділ або товар: ",
		"loading": "Завантаження...",
		"adding": "Додавання...",
		"addToCompare": "Добавить к сравнению",
		"chooseProduct": "Оберіть товар",
		"chooseSection": "Оберіть розділ",
	}
}

export default langData